import React from "react";
import {
  faDiscord,
  faFacebook,
  faFacebookF,
  faFacebookMessenger,
  faFlipboard,
  faGetPocket,
  faGoogle,
  faInstagram,
  faLine,
  faLinkedin,
  faLinkedinIn,
  faPinterest,
  faPinterestP,
  faQuora,
  faReddit,
  faRedditAlien,
  faSkype,
  faSnapchat,
  faStackExchange,
  faStackOverflow,
  faTelegram,
  faTumblr,
  faTwitter,
  faWhatsapp,
  faXTwitter,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEnvelope,
  faMailBulk,
  faMailForward,
  faMessage,
} from "@fortawesome/free-solid-svg-icons";

import {
  faMessage as faMessageLight,
  faEnvelope as faEnvelopeLight,
} from "@fortawesome/free-regular-svg-icons";

export const socialMedia = {
  facebook: {
    id: "facebook",
    name: "Facebook",
    color: "#3b5998",
    icon: <FontAwesomeIcon width={30} icon={faFacebook} />,
    iconLight: <FontAwesomeIcon width={30} icon={faFacebookF} />,
  },
  youtube: {
    id: "youtube",
    name: "Youtube",
    color: "red",
    icon: <FontAwesomeIcon width={30} icon={faYoutube} />,
  },
  instagram: {
    id: "instagram",
    name: "Instagram",
    color: "#d62976",
    icon: <FontAwesomeIcon width={30} icon={faInstagram} />,
  },
  whatsapp: {
    id: "whatsapp",
    name: "Whatsapp",
    color: "#25D366",
    icon: <FontAwesomeIcon width={30} icon={faWhatsapp} />,
  },
  google: {
    id: "google",
    name: "Google",
    color: "#4285F4",
    icon: <FontAwesomeIcon width={30} icon={faGoogle} />,
  },
  linkedin: {
    id: "linkedin",
    name: "Linkedin",
    color: "#0077b5",
    icon: <FontAwesomeIcon width={30} icon={faLinkedin} />,
    iconLight: <FontAwesomeIcon width={30} icon={faLinkedinIn} />,
  },
  telegram: {
    id: "telegram",
    name: "Telegram",
    color: "#0088cc ",
    icon: <FontAwesomeIcon width={30} icon={faTelegram} />,
  },
  pinterest: {
    id: "pinterest",
    name: "Pinterest",
    color: "#E60023",
    icon: <FontAwesomeIcon width={30} icon={faPinterest} />,
    iconLight: <FontAwesomeIcon width={30} icon={faPinterestP} />,
  },
  quora: {
    id: "quora",
    name: "Quora",
    color: "#b92b27",
    icon: <FontAwesomeIcon width={30} icon={faQuora} />,
  },
  skype: {
    id: "skype",
    name: "Skype",
    color: "#00aff0",
    icon: <FontAwesomeIcon width={30} icon={faSkype} />,
  },
  stackoverflow: {
    id: "stackoverflow",
    name: "Stackoverflow",
    color: "#ef8236",
    icon: <FontAwesomeIcon width={30} icon={faStackOverflow} />,
  },
  stackexchange: {
    id: "stackexchange",
    name: "Stack Exchange",
    color: "#376db6",
    icon: <FontAwesomeIcon width={30} icon={faStackExchange} />,
  },
  twitter: {
    id: "twitter",
    name: "Twitter",
    color: "#1DA1F2",
    icon: <FontAwesomeIcon width={30} icon={faXTwitter} />,
  },
  reddit: {
    id: "reddit",
    name: "Reddit",
    color: "#ff4500",
    icon: <FontAwesomeIcon width={30} icon={faReddit} />,
    iconLight: <FontAwesomeIcon width={30} icon={faRedditAlien} />,
  },
  snapchat: {
    id: "snapchat",
    name: "Snapchat",
    color: "#FFFC00",
    icon: <FontAwesomeIcon width={30} icon={faSnapchat} />,
  },
  messenger: {
    id: "messenger",
    name: "Messenger",
    color: "#006AFF",
    icon: <FontAwesomeIcon width={30} icon={faFacebookMessenger} />,
  },
  discord: {
    id: "discord",
    name: "Discord",
    color: "#7289da",
    icon: <FontAwesomeIcon width={30} icon={faDiscord} />,
  },
  flipboard: {
    id: "flipboard",
    name: "Flipboard",
    color: "#e12828",
    icon: <FontAwesomeIcon width={30} icon={faFlipboard} />,
  },
  line: {
    id: "line",
    name: "Line",
    color: "#00c300",
    icon: <FontAwesomeIcon width={30} icon={faLine} />,
  },
  pocket: {
    id: "pocket",
    name: "Pocket",
    color: "#ef4056",
    icon: <FontAwesomeIcon width={30} icon={faGetPocket} />,
  },
  sms: {
    id: "sms",
    name: "SMS",
    color: "#ef4056",
    icon: <FontAwesomeIcon width={30} icon={faMessage} />,
    iconLight: <FontAwesomeIcon width={30} icon={faMessageLight} />,
  },
  tumblr: {
    id: "tumblr",
    name: "Tumblr",
    color: "#ef4056",
    icon: <FontAwesomeIcon width={30} icon={faTumblr} />,
  },
  print: {
    id: "print",
    name: "Print",
    color: "#168de2",
    icon: <FontAwesomeIcon width={30} icon={faEnvelope} />,
    iconLight: <FontAwesomeIcon width={30} icon={faEnvelopeLight} />,
  },
};
